import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Layout/Header";

const Topbar = () => {
  const [showdropdownsmall, setShowdropdownsmall] = useState(false);

  return (
    <>
      <Header activeHeading={1} />

      <nav className="bg-gray-300 dark:bg-gray-900">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-start md:justify-center lg:justify-center xl:justify-center mx-auto p-3">
          <button
            onClick={() => setShowdropdownsmall(!showdropdownsmall)}
            data-collapse-toggle="navbar-default"
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-default"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div
            className={`${
              showdropdownsmall ? "" : "hidden"
            } w-full md:block md:w-auto`}
            id="navbar-default"
          >
            <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg  md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0  dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
              <li>
                <Link
                  to="/pepdite-information"
                  className="block py-2 px-3 text-white hover:text-green-500 transition-all duration-300 rounded md:bg-transparent md:p-0 dark:text-white"
                  aria-current="page"
                >
                  Glossary Home
                </Link>
              </li>
              <li>
                <Link
                  to="/pepdite-information/peptide"
                  className="block py-2 px-3 text-white hover:text-green-500 transition-all duration-300 rounded md:bg-transparent md:p-0 dark:text-white"
                >
                  Intro to Peptides
                </Link>
              </li>
              <li>
                <Link
                  to="/pepdite-information/peptide-reconstitution"
                  className="block py-2 px-3 text-white hover:text-green-500 transition-all duration-300 rounded md:bg-transparent md:p-0 dark:text-white"
                >
                  Peptide Reconstitution
                </Link>
              </li>
              <li>
                <Link
                  to="/pepdite-information/peptide-storage"
                  className="block py-2 px-3 text-white hover:text-green-500 transition-all duration-300 rounded md:bg-transparent md:p-0 dark:text-white"
                >
                  Peptide Storage
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Topbar;
